import { JSX } from "react";
import apiClient from "../apiClient";

const baseUrl = '/doc/rich'

export type MenuStatus = 'enabled' | 'disabled';

export type DocMenuItem = {
    _id: string;
    name: string;
    path: string;
    component?: string;
    layout?: boolean;
    icon?: JSX.Element;
    order?: number;
    description?: string;
    status: MenuStatus;
    createdAt?: string;
    updatedAt?: string;
};

export async function getDocRich(menuCode: string) {
    return apiClient<{
        data: DocMenuItem[]
    }>(baseUrl, {
        method: 'GET',
        params: { menuCode },
    });
}

export async function saveDocRich(data: Partial<DocMenuItem> & { menuCode: string }) {
    return apiClient(baseUrl, {
        method: 'POST',
        data,
    });
}

export async function updateDocRich(id: string, data: Partial<DocMenuItem>) {
    return apiClient(`${baseUrl}/${id}`, {
        method: 'PUT',
        data,
    });
}

// 上传图片
export async function uploadDocImage(data: any) {
    return apiClient<{ url: string }>('doc/upload', {
        method: 'POST',
        data,
    });
}
